<template>
    <select
        ref="select"
        v-model="valueModel"
        class="form-control"
    >
        <option 
            v-for="item in options"
            :key="val(item)"
            :value="val(item)"
            :selected="selected(item)"
        >
            {{text(item)}}
        </option>
    </select>
</template>

<script>

import $ from 'jquery';

export default {
    name: 'dropdown',
    created() {
        const vm = this;
        this.valueModel = this.value; 

        //If null or undefined
        if(this.valueModel == null) {
            if(this.datasource.length != 0) {
                this.valueModel = this.options[0].value;
            }
        }
    },
    methods: {
        val(item) {
            return item.Value || item.value;
        },
        text(item) {
            return item.Text || item.text;
        },
        selected(item) {
            return this.valueModel === this.val(item);
        }
    },
    computed: {
        datasourceHasValues() {
            return this.datasource.length != 0
        },
        options() {
            const vm = this;
            let options = [];

            if(vm.placeholder !== null) {
                options.push({ text: vm.placeholder, value: null });
            }

            if(vm.textField && vm.valueField) {                
                options = options.concat(vm.datasource.map((item) => {
                    return {
                        text: item[vm.textField],
                        value: item[vm.valueField]
                    };
                }));
            } else {
                options = options.concat(vm.datasource);
            }
            return options;
        }
    },
    watch: {
        valueModel(value) {
            if(value !== this.value) {
                this.$emit('input', value);
            }
        }
    },
     data() {
        return { 
            valueModel: undefined
        };
    },
    props: {
        datasource: {
            type: Array,
            required: true
        },
        value: {
            type: String,
            default: null
        },
        placeholder: {
            type: String,
            default: null
        },
        textField: {
            type: String,
            default: null
        },
        valueField: {
            type: String,
            default: null
        }
    }
};
</script>

<style lang="scss" scoped src="./Style/dropdown.scss">

</style>